import { REPORT_PRINT_PREPARE_EVENT } from './reportMapPrinting';

const printableTitle = (title: string) =>
    title.replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim() || 'IntelOptics Report';

export const printRenderedReport = (title: string, target?: HTMLElement | null) => {
    const reports = Array.from(document.querySelectorAll<HTMLElement>('.analysis-report-print-area'));
    const report = target || reports.find(candidate => !candidate.parentElement?.closest('.analysis-report-print-area'));
    if (!report) {
        window.print();
        return;
    }

    const previousTitle = document.title;
    const ancestors: HTMLElement[] = [];
    for (let ancestor = report.parentElement; ancestor; ancestor = ancestor.parentElement)
        ancestors.push(ancestor);
    let restored = false;
    const restore = () => {
        if (restored)
            return;
        restored = true;
        document.body.classList.remove('analysis-report-printing');
        report.removeAttribute('data-print-root');
        ancestors.forEach(ancestor => ancestor.removeAttribute('data-print-ancestor'));
        document.title = previousTitle;
    };

    window.dispatchEvent(new CustomEvent(REPORT_PRINT_PREPARE_EVENT, { detail: report }));
    document.title = printableTitle(title);
    report.setAttribute('data-print-root', '');
    ancestors.forEach(ancestor => ancestor.setAttribute('data-print-ancestor', ''));
    document.body.classList.add('analysis-report-printing');
    window.addEventListener('afterprint', restore, { once: true });
    window.setTimeout(restore, 60000);
    // Reflow to paper size, redraw maps, then let the browser paint before capture.
    requestAnimationFrame(() => requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!restored)
            window.print();
    })));
};
